import React, { Component } from 'react';
import maingif from "../assets/images/1.gif";
class HomePage extends Component {
  render() {
    return (
     	
     	<section>
<div className="row">
        <div className="thumbnail-wrapper ">
        <img id="aftr-ld" src={maingif} className=" rof img-responsive" alt="web development"/>
        </div>
      </div>
     		<div className="container aboutuspage">
     			<div className="myclr">
     				<div className="row add-m-top-50">
     					 <div className="pagination-centered text-center"> 
			            	<h2 className="animation-box wow bounceIn animated black">WHO WE ARE</h2>
			        	</div>
     				</div>

     				<div className="row">
                     <p className="txt-cntr p-20">  Garymark Infotech is a professional information technology solution provider focusing on total software solutions and web technologies worldwide. We are providing affordable web design services, web development services, seo services, php application development etc. Create websites that increase our customer's online visibility and brand....<a href="about-us.php">Read More</a>  </p>
        			</div>

        			<div className="col-md-3 null-p">
                      <article className="first-child">
                      <div className="start">
                          <i className="fa fa-coffee fa-fw fa-5x"></i>
                          <span className="stat-count">200</span>
                        </div>
                         <h4>200+ Coffee Chats</h4>
                          <p  className="stat-label">Drop in anytime for an intimate coffee chat with the Garymark team about your goals.  We'll help you figure out in <b>Design</b> or <b>Development</b> what might be a good fit for your answered questions.</p>
                        </article>
                     </div>

                     <div className="col-md-3 null-p">
                        <article >
                          <div className="start">
                            <i className="fa fa-code fa-fw fa-5x"></i>
                            <span className="stat-count">100</span>
                          </div>
                          <h4>100+ Projects Completed</h4>
                          <p className="stat-label">We  maintain trusting, mutually beneficial relationships with our clients. We offer professional solutions for your online business needs. </p>
                          </article>
                        </div>

                          <div className="col-md-3 null-p">
                          <article >
                            <div className="start">
                              <i className="fa fa-leaf fa-fw fa-5x"></i>
                              <span className="stat-count">01</span>
                            </div>
                            <h4>01+ Springs Covered</h4>
                            <p className="stat-label">Our clients are very happy with what we produce. The measurement of our success is based on how happy the clients are at the final result. We take time to listen and to learn what the client wants.  </p>
                            </article>
                          </div>

                           <div className="col-md-3 null-p">
                            <article className="nth-child">
                              <div className="start">
                                <i className="fa fa-smile-o  fa-fw fa-5x"></i>
                                <span className="stat-count">100</span>
                              </div>
                              <h4>100+ Happy Clients</h4>
                              <p className="stat-label">Our clients are very happy with what we produce. The measurement of our success is based on how happy the clients are at the final result</p>
                              </article>
                            </div>




     			</div>


     			<div className="row">
<div className="col-md-12 add-m-20"> 
<div className="pagination-centered text-center"> 
<h2 className="animation-box wow bounceIn animated black">TECHNOLOGIES WE SPECIALIZE IN</h2>
</div>
<section className="add-m-top-30 add-m-btm-50 port-bg ">
<div className="row">
<div className="pagination-centered text-center">
<ul className="soci-at add-m-top-50 cir null-p">
  <li><i className="fa fa-4x fa-html5 wow slideInDown" ></i></li>
  <li><i className="fa fa-4x fa-css3 wow slideInLeft" ></i></li>
  <li><i className="fa fa-4x fa-joomla wow slideInDown" ></i></li>
  <li><i className="fa fa-4x fa-maxcdn wow slideInLeft" ></i></li>
  <li><i className="fa fa-4x fa-jsfiddle wow slideInRight" ></i></li>
  <li><i className="fa fa-4x fa-github-alt wow slideInLeft" ></i></li>
  <li><i className="fa fa-4x fa-linux wow slideInDown" ></i></li>
  <li><i className="fa fa-4x fa-codepen wow slideInRight" ></i></li>
</ul>
</div>
</div>
</section>
</div>
</div>



     		</div>

     		      <div className="container-fluid null-p">


<section className="at-animation">

<div className="col-md-4 null-p">
<section className="my-btm1">
<div className="at-content">
<i className="fa fa-4x fa-code atuls" ></i>
<h3 className="hd1">DEVELOPMENT OF SOFTWARES</h3>
    <ul className="to-hide1">
      <li><i className="fa fa-cog fa-fw "></i>Web sites and platforms development</li>
      <li><i className="fa fa-cog fa-fw "></i>Mobile applications development</li>
      <li><i className="fa fa-cog fa-fw "></i>Business process automation</li>
      <li><i className="fa fa-cog fa-fw "></i>Adaptation for mobile devices</li>
      <li><i className="fa fa-cog fa-fw "></i>Development of management and accounting systems</li>
    </ul>
     <a   href="#" className="btn btn-download wow  fadeInUp animated atu1"  ><i className="fa fa-eye "></i> <br/>VIEW </a>
</div>
</section>
</div>

<div className="col-md-4 null-p">
<section className="my-btm2">
<div className="at-content">
<i className="fa  fa-4x fa-paint-brush atuls"></i>
<h3 className="hd2">DESIGN OF INTERFACES</h3>
  <ul className="to-hide2">
    <li><i className="fa fa-cog fa-fw "></i>Creative concept development</li>
    <li> <i className="fa fa-cog fa-fw "></i>Usability testing and development</li>
      <li><i className="fa fa-cog fa-fw "></i>User interface design</li>
      <li><i className="fa fa-cog fa-fw "></i>Data visualization</li>
      <li><i className="fa fa-cog fa-fw "></i>Adaptive design creation</li>
  </ul>
  <a  href="#" className="btn btn-download wow  fadeInUp animated atu2"><i className="fa fa-eye "></i> <br/>VIEW</a>
</div>
</section>
</div>

<div className="col-md-4 null-p">
<section className="my-btm3">
<div className="at-content">
   <i className="fa fa-4x fa-area-chart atuls"></i>
  <h3 className="hd3" >TRIPMAKER SOFTWARE</h3>
  <ul className="to-hide3">
    <li><i className="fa fa-cog fa-fw "></i>Regular Transactions</li>
    <li> <i className="fa fa-cog fa-fw "></i>Tour Booking Details</li>
    <li><i className="fa fa-cog fa-fw "></i>Realtime Updates & Alerts</li>
    <li><i className="fa fa-cog fa-fw "></i>Automated Account Details</li>
    <li><i className="fa fa-cog fa-fw "></i>Regular Packages & Wbsite Leads</li>
    <li><i className="fa fa-cog fa-fw "></i>Complete Data Master</li>
    <li><i className="fa fa-cog fa-fw "></i>High Security</li>
  </ul>
   <a  href="#" className="btn btn-download wow  fadeInUp animated atu3"><i className="fa fa-eye "></i> <br/>VIEW </a>
</div>
</section>
</div>

</section>


</div>


<div className="container-fluid null-p">
  
  <section className="img-atulsunil"> 
<section id="home_theme_text" className=" text-center sml-img" >
 
     
      <div className="row">
       
          <div className="home-theme-text">
            <p>
              we have 50+ unique themes for your next website project
            </p>
            <a className="main-button button-blue" href="portfolio.php">EXPLORE OUR PORTFOLIO</a>
          </div>
       
      </div>
     
   

</section>
</section>




</div>



<div className="container">

<div className="col-md-12 add-m-top-100 add-m-btm-100">
<div className="col-md-6">
<section id="clients" >
<section > <b> CLIENTS</b></section><hr/>
        <div className="carousels slide add-m-top-5" data-ride="carousel ">
          <div className="carousel-inner">
                <div className="item active">
                  <div className="col-lg-4 col-xs-4 col-md-4 col-sm-4">
                 <a href="#"> <img src="http://res.cloudinary.com/atul-cdn/image/upload/v1457171161/2_kqfrix.jpg" width="400" height="200" className="img-responsive" alt="webdesign-clients"/></a>
                  </div>
                  <div className="col-lg-4 col-xs-4 col-md-4 col-sm-4">
                 <a href="#"> <img src="http://res.cloudinary.com/atul-cdn/image/upload/v1457171165/4_fvudcd.jpg" width="400" height="200" className="img-responsive" alt="webdesign-clients"/></a>
                  </div>
                    <div className="col-lg-4 col-xs-4 col-md-4 col-sm-4">
                 <a href="#"> <img src="http://res.cloudinary.com/atul-cdn/image/upload/v1457171165/4_fvudcd.jpg" width="400" height="200" className="img-responsive " alt="webdesign-clients"/></a>
                  </div>
                </div>
                   <div className="item ">
                  <div className="col-lg-4 col-xs-4 col-md-4 col-sm-4">
                 <a href="#"> <img src="http://res.cloudinary.com/atul-cdn/image/upload/v1457171165/4_fvudcd.jpg" width="400" height="200" className="img-responsive" alt="webdesign-clients"/></a>
                  </div>
                    <div className="col-lg-4 col-xs-4 col-md-4 col-sm-4">
                 <a href="#"> <img src="http://res.cloudinary.com/atul-cdn/image/upload/v1457171161/2_kqfrix.jpg" width="400" height="200" className="img-responsive" alt="webdesign-clients"/></a>
                  </div>
                    <div className="col-lg-4 col-xs-4 col-md-4 col-sm-4">
                 <a href="#"> <img src="http://res.cloudinary.com/atul-cdn/image/upload/v1457171165/4_fvudcd.jpg" width="400" height="200" className="img-responsive" alt="webdesign-clients"/></a>
                  </div>
                </div>
            </div>
        </div>

</section>
</div>

<div className="col-md-6">
<section id="testimonials">
<section ><b>TESTIMONIALS  </b></section><hr/>
<div id="carousel-example-generic" className="carousel slide add-m-top-5" data-ride="carousel">
  
  <div className="carousel-inner">
  
    <div className="item active container add-fr">
    <i className="fa fa-2x fa-fw fa-quote-left"></i><p>
Thank you all for the amount of effort and time that you’ve put into my website.
</p><i className="fa fa-2x fa-fw fa-quote-right "></i>
     <p><b>Rohit Ragav Leme S (CEO -Insaiba Technologies)</b></p>
    </div>

    <div className="item container add-fr">
    <i className="fa fa-2x fa-fw fa-quote-left"></i><p>
I appreciate the team’s efforts for building this fantastic site.
</p><i className="fa fa-2x fa-fw fa-quote-right "></i>
     <p><b>joe Leme S (CEO -Vertico)</b></p>
    </div>

    <div className="item container add-fr">
    <i className="fa fa-2x fa-fw fa-quote-left"></i><p>
Working with Garymark has been a very good & positive experience.
</p><i className="fa fa-2x fa-fw fa-quote-right "></i>
     <p><b>James S (CEO -Softcore)</b></p>
    </div>

    <div className=" add-m-top-20 add-m-lft-10 txt-cntr " >
     <a className="left" href="#carousel-example-generic" data-slide="prev">
           <i className="fa fa-dot-circle-o"></i>

          </a>
          <a className="right" href="#carousel-example-generic" data-slide="next">
           <i className="fa fa-dot-circle-o"></i>

          </a>
    </div>

</div>
</div>
</section>
</div>
</div>
</div>




     	</section>
    );
  }
}

export default HomePage;



// WEBPACK FOOTER //
// ./src/pages/homePage.js